import { API_BASE_URL, apiRoutes } from "../../../constants";

import React, { useCallback, useRef, useState } from "react";

import Axios from "axios";

const pageSize = 10;

const getSerializedParam = (
  objectToSerialize,

  filterName,

  currentFilter = "",
) => {
  for (const [, [key, value]] of Object.entries(
    Object.entries(objectToSerialize),
  )) {
    if (value !== "" && value) {
      currentFilter += `${
        currentFilter.length ? "&" : ""
      }${filterName}[${key}]=${encodeURIComponent(value)}`;
    }
  }

  return currentFilter;
};

const formatSiteApiData = (apiRes) =>
  apiRes?.map((resData) => {
    const apiAttributes = resData?.attributes;

    delete resData?.attributes;

    return { ...resData, ...apiAttributes };
  });

const getSiteOptions = (siteData, excludeSelectOption) => {
  let siteArray = [];

  if (siteData?.length > 0) {
    _.forEach(_.orderBy(siteData, "name", "asc"), (site) => {
      siteArray.push({
        label: site.name,

        value: site.id,
      });
    });
  }

  return siteArray;
};

const useSiteOptions = (excludeSelectOption = false) => {
  const [sites, setSites] = useState([]);
  const [isSiteLoading, setIsSiteLoading] = useState(false);
  const [prevSearchQuery, setPrevSearchQuery] = useState("");
  const [currSearchQuery, setCurrSearchQuery] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageEnd, setPageEnd] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const loadingRef = useRef(false);
  const isMountedRef = useRef(true);
  const lastLoadedPageRef = useRef(0);
  const sitesRef = useRef([]);
  const lastCallTimeRef = useRef(0); // NEW: Track last call time

  const token = localStorage.getItem("access_token");
  const config = {
    headers: {
      Authorization: `JWT ${token}`,
      "content-type": "multipart/form-data",
    },
  };

  React.useEffect(() => {
    sitesRef.current = sites;
  }, [sites]);

  React.useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getSiteSelectedOption = (siteIDValue) => {
    let siteObj = null;
    if (sites?.length > 0) {
      const selectedOption = _.find(
        sites,
        (siteData) => siteData?.value === siteIDValue,
      );
      if (selectedOption) siteObj = { ...selectedOption };
    }
    return siteObj;
  };

  const getPaginationSettings = (page) => ({
    size: pageSize,
    number: page,
  });

  const loadNextSiteOptionsPage = useCallback(async () => {
    const currentSitesLength = sitesRef.current.length;
    const currentPage = Math.max(
      1,
      Math.floor(currentSitesLength / pageSize) + 1,
    );

    const now = Date.now();

    if (loadingRef.current || pageEnd || hasError || isSiteLoading) {
      return;
    }

    if (currentPage <= lastLoadedPageRef.current) {
      return;
    }

    if (
      currentSitesLength > 0 &&
      totalCount > 0 &&
      currentSitesLength >= totalCount
    ) {
      setPageEnd(true);
      return;
    }

    lastLoadedPageRef.current = currentPage;

    loadingRef.current = true;

    if (currentPage === 1) {
      setIsSiteLoading(true);
    }

    const page = currentPage;

    let filter = "";
    filter = getSerializedParam(getPaginationSettings(page), "page", filter);

    if (String(currSearchQuery ?? "").length)
      filter = getSerializedParam(
        { search: currSearchQuery },
        "filter",
        filter,
      );

    setCurrPage(page);

    const searchURL = new URL(`${API_BASE_URL}${apiRoutes.site}`);
    searchURL.search = filter;

    setHasError(false);

    Axios.get(searchURL, config)
      .then(({ data: apiData }) => {
        if (!isMountedRef.current) return;

        if (!apiData?.data?.length) {
          setPageEnd(true);
        } else {
          const formatedData = formatSiteApiData(apiData?.data);
          const newOptions = getSiteOptions(formatedData, excludeSelectOption);

          setSites((currsites) => {
            const updated = [...currsites, ...newOptions];
            sitesRef.current = updated;
            return updated;
          });
          setTotalCount(apiData?.meta?.pagination?.count);
        }

        setIsInitialized(true);
      })
      .catch((error) => {
        if (!isMountedRef.current) return;

        lastLoadedPageRef.current = page - 1;

        setHasError(true);
        setPageEnd(true);
      })
      .finally(() => {
        if (!isMountedRef.current) return;

        // Only update loading state if we set it (for first page)
        if (page === 1) {
          setIsSiteLoading(false);
        }

        setTimeout(() => {
          loadingRef.current = false;
        }, 150);
      });
  }, [
    pageEnd,
    hasError,
    isSiteLoading,
    totalCount,
    currSearchQuery,
    excludeSelectOption,
  ]);

  const searchSiteOptions = (resolveCallback, searchQuery) => {
    if (loadingRef.current) {
      resolveCallback(sitesRef.current);
      return;
    }

    loadingRef.current = true;
    setCurrSearchQuery(searchQuery);
    setCurrPage(1);
    setPageEnd(false);
    setHasError(false);
    lastLoadedPageRef.current = 0;
    lastCallTimeRef.current = 0; // NEW: Reset on search

    let filter = "";
    filter = getSerializedParam(getPaginationSettings(1), "page", filter);

    if (String(searchQuery ?? "").length)
      filter = getSerializedParam({ search: searchQuery }, "filter", filter);

    const searchURL = new URL(`${API_BASE_URL}${apiRoutes.site}`);
    searchURL.search = filter;

    setIsSiteLoading(true);

    Axios.get(searchURL, config)
      .then(({ data: apiData }) => {
        if (!isMountedRef.current) return;

        if (!apiData?.data?.length) {
          resolveCallback(getSiteOptions([], excludeSelectOption));
          setTotalCount(0);
          setPageEnd(true);
          setSites([]);
          sitesRef.current = [];
        } else {
          const formatedData = formatSiteApiData(apiData?.data);
          const newOptions = getSiteOptions(formatedData, excludeSelectOption);

          setSites(newOptions);
          sitesRef.current = newOptions;
          setTotalCount(apiData?.meta?.pagination?.count);
          resolveCallback(newOptions);
          lastLoadedPageRef.current = 1;

          if (
            apiData?.meta?.pagination?.count <=
            apiData?.meta?.page * pageSize
          )
            setPageEnd(true);
        }

        setPrevSearchQuery(searchQuery);
        setIsInitialized(true);
      })
      .catch((error) => {
        if (!isMountedRef.current) return;
        setHasError(true);
        resolveCallback(getSiteOptions([], excludeSelectOption));
        setSites([]);
        sitesRef.current = [];
      })
      .finally(() => {
        if (!isMountedRef.current) return;
        setIsSiteLoading(false);
        loadingRef.current = false;
      });
  };

  const handleSiteSearch = useCallback(
    (searchValue, onResolveCallBack = () => {}) => {
      if (searchValue === "" && prevSearchQuery === "" && isInitialized) {
        onResolveCallBack(sitesRef.current);
        return;
      }

      if (searchValue == "" && String(prevSearchQuery ?? "").length == 0)
        return;

      if (_.inRange(String(searchValue ?? "").length, 1, 2)) {
        if (String(prevSearchQuery ?? "").length >= 2) {
          searchSiteOptions(onResolveCallBack, "");
          return;
        } else {
          onResolveCallBack(sitesRef.current);
          return;
        }
      }

      searchSiteOptions(onResolveCallBack, searchValue);
    },
    [prevSearchQuery, isInitialized],
  );

  const getAllSites = useCallback(() => {
    const searchURL = new URL(
      `${API_BASE_URL}${apiRoutes.site}?page[size]=3000`,
    );

    setIsSiteLoading(true);

    Axios.get(searchURL)
      .then(({ data: apiData }) => {
        if (!isMountedRef.current) return;
        const formattedData = formatSiteApiData(apiData?.data);
        const newOptions = getSiteOptions(formattedData, excludeSelectOption);
        setSites(newOptions);
        sitesRef.current = newOptions;
      })
      .finally(() => {
        if (!isMountedRef.current) return;
        setIsSiteLoading(false);
      });
  }, [excludeSelectOption]);

  return {
    sites,
    handleSiteSearch,
    loadNextSiteOptionsPage,
    getSiteSelectedOption,
    getAllSites,
    isSiteLoading,
    hasError,
  };
};

export default useSiteOptions;
